<div class="modal-body modal-scss" style="height:70vh; overflow-y:scroll">
    <app-contact-details [contactId]="data?.id" [displayedInModal]="true"></app-contact-details>
</div>